// extracted by mini-css-extract-plugin
export default {"container":"About_container__WazHV","lydiaphoto":"About_lydiaphoto__3hT16","biotitle":"About_biotitle__-rC-a","getintouch":"About_getintouch__X44L0","iconimg":"About_iconimg__NszRF"};